import dynamic from 'next/dynamic';

const ArnmMaintenanceGrid = dynamic(() =>
  import('./ArnmMaintenanceGrid/ArnmMaintenanceGrid')
);
const AddArnmMaintenanceModal = dynamic(() =>
  import('./AddArnmMaintenanceModal/AddArnmMaintenanceModal')
);

const ArnmMaintenanceVehicleHeader = dynamic(() =>
  import('./ArnmMaintenanceVehicleHeader/ArnmMaintenanceVehicleHeader')
);

const ArnmMaintenanceFilter = dynamic(() =>
  import('./ArnmMaintenanceFilter/ArnmMaintenanceFilter')
);
const MaintenanceForm = dynamic(() =>
  import('./MaintenanceForm/MaintenanceForm')
);
const ArnmMaintenanceContent = dynamic(() =>
  import('./ArnmMaintenanceContent/ArnmMaintenanceContent')
);

export {
  ArnmMaintenanceGrid,
  AddArnmMaintenanceModal,
  ArnmMaintenanceVehicleHeader,
  ArnmMaintenanceFilter,
  MaintenanceForm,
  ArnmMaintenanceContent,
};
